import { makeAutoObservable } from 'mobx'
import * as API from '../../../service/api/InfoStat/ReportManageApi'
import table from '../../commons/table'
import { downloadFileStream } from '../../../util'

class ReportManageStore {
  constructor() {
    makeAutoObservable(this)
  }

  get table() {
    return new table(API.GET_REPORT_LOG_LIST)
  }

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  exportLog = async (data) => {
    let res = await API.EXPORT_REPORT_LOG_LIST(data)
    downloadFileStream(res, '营业数据')
  }
}

export default new ReportManageStore()
